<body class='login'>


    <mat-card class="card">
        <img src="../../../assets/logo-1.jpg" alt="Tumsa Logo">
        <mat-card-content>

            <form [formGroup]="options" (ngSubmit)="save()">

                <mat-form-field appearance="fill" [hideRequiredMarker]="hideRequiredControl.value"
                    [floatLabel]="floatLabelControl.value">
                    <input matInput formControlName="name" placeholder="Nombre" required
                        oninput="this.value = this.value.toUpperCase()">
                </mat-form-field>
                <mat-error *ngIf="options.get('name').errors && options.get('name').touched">Por favor introduzca un
                    nombre válido</mat-error>

                <mat-form-field appearance="fill" [hideRequiredMarker]="hideRequiredControl.value"
                    [floatLabel]="floatLabelControl.value">
                    <input matInput formControlName="lastname" placeholder="Apellidos" required
                        oninput="this.value = this.value.toUpperCase()">
                </mat-form-field>
                <mat-error *ngIf="options.get('lastname').errors && options.get('lastname').touched">Por favor
                    introduzca un apellido válido</mat-error>

                <mat-form-field appearance="fill" [hideRequiredMarker]="hideRequiredControl.value"
                    [floatLabel]="floatLabelControl.value">
                    <input matInput formControlName="curp" placeholder="CURP" required
                        oninput="this.value = this.value.toUpperCase()">
                </mat-form-field>
                <mat-error *ngIf="options.get('curp').errors && options.get('curp').touched">Por favor
                    introduzca CURP válida</mat-error>

                <mat-form-field appearance="fill" [hideRequiredMarker]="hideRequiredControl.value"
                    [floatLabel]="floatLabelControl.value">
                    <input matInput formControlName="license" placeholder="Licencia" required
                        oninput="this.value = this.value.toUpperCase()">
                </mat-form-field>
                <mat-error *ngIf="options.get('license').errors && options.get('license').touched">Por favor
                    introduzca una licencia válida</mat-error>

                    <mat-form-field appearance="fill" [hideRequiredMarker]="hideRequiredControl.value"
                    [floatLabel]="floatLabelControl.value">
                    <input [(ngModel)]="password" matInput type="text" formControlName="password" placeholder="Contraseña" required>
                </mat-form-field>
                <mat-error *ngIf="options.get('password').errors && options.get('password').touched" >Por favor
                    introduzca un password válido</mat-error>

                    <button mat-stroked-button type="submit" [disabled]="!options.valid">Enviar</button>
                </form>

        </mat-card-content>
    </mat-card>



</body>